module.exports = __webpack_public_path__ + "static/media/mockup4.727bbbb5.png";